import { Component, OnInit } from '@angular/core';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';
import { TrinityService } from './services/trinity.service';

@Component({
  selector: 'app-trinity',
  templateUrl: './trinity.component.html',
  styleUrls: ['./trinity.component.scss']
})
export class TrinityComponent implements OnInit {
  accessRoles: any;
  constructor(
    public sidePanelService:SidePanelService,
    public trinityService:TrinityService
  ) { 
    this.sidePanelService.initSideDrawer('ama');
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
  }

  ngOnInit(): void {
  }


  onSearchChange(searchText: string) {
    this.trinityService.headerSearchEvent.emit(searchText);
  }

}
